/**
 * Én regel: servertekst vises kun, hvis den er skrevet til brugeren.
 *
 * Cloud-koden har 138 engelske fejlstrenge i filer med en HTTP-handler
 * (optalt 13. aug 2026), og temaets egne PHP-handlere har flere. Langt de
 * fleste er integritetsværn, der kun fyrer på misdannet input — "Lead
 * disappeared while persisting Adversus result", "Additional phones did not
 * save correctly in WordPress." De er skrevet til den, der læser en log, ikke
 * til en dansk supporter midt i en arbejdsdag. Alligevel blev de sendt ordret
 * videre til hendes skærm, fordi 56 kaldsteder gjorde
 * `response?.data?.message || msg.error`.
 *
 * At oversætte dem alle ville være en stor diff på tekst, ingen bør møde, og
 * det ville gøre logsøgning sværere: fejlen ville hedde én ting i koden og en
 * anden i Sentry. Så i stedet lukkes lækagen her.
 *
 * Serveren kan sende `user_message: true` sammen med beskeden, når teksten
 * FAKTISK er skrevet til brugeren — fx en formularvalidering. Så slipper den
 * igennem. Ellers vinder kaldstedets danske reserve.
 *
 * Ligger for sig selv og ikke i components/receipts.js, fordi flere af
 * kaldstederne (helpers/popup-render-cloud.js, templates/days-off.js m.fl.)
 * ikke har brug for notyf og ikke skal trække det med ind.
 *
 * @param {object} payload Svarets data-objekt (eller svaret selv).
 * @returns {string} Beskeden, eller tom streng når den er intern.
 */
export function userMessage(payload) {
    if (!payload) {
        return '';
    }

    const erTilBrugeren = payload.user_message === true || payload.user_message === 1;

    return erTilBrugeren ? (payload.message || '') : '';
}

export default userMessage;
